import React from 'react';

/**
 * Warning indicator SVG icon.
 *
 * @param {React.SVGProps<SVGSVGElement>} props - Standard SVG element properties
 * @returns {React.ReactElement}
 */
const WarningIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="10" cy="10" r="9" fill="#F2994A" />
    <path d="M10 6V11" stroke="white" strokeWidth="2" strokeLinecap="round" />
    <circle cx="10" cy="14" r="1.25" fill="white" />
  </svg>
);

export default WarningIcon;